import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "d-flex d-space-between" },
    [
      _c(
        VAutocomplete,
        _vm._b(
          {
            ref: "autocomplete",
            attrs: {
              items: _vm.suggestionList,
              loading: _vm.isAppLoading,
              "search-input": _vm.search,
              "hide-no-data": "",
              "hide-selected": "",
              "no-filter": "",
              clearable: "",
              outlined: "",
              "item-text": _vm.suggestionText,
              "item-value": _vm.suggestionValue,
              label: _vm.label,
              "prepend-icon": _vm.icon,
              "return-object": _vm.returnObject,
            },
            on: {
              "update:searchInput": function ($event) {
                _vm.search = $event
              },
              "update:search-input": function ($event) {
                _vm.search = $event
              },
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                )
                  return null
                return _vm.selectedSuggestion.apply(null, arguments)
              },
              "click:clear": function ($event) {
                return _vm.clearSearch()
              },
            },
            model: {
              value: _vm.suggestion,
              callback: function ($$v) {
                _vm.suggestion = $$v
              },
              expression: "suggestion",
            },
          },
          "v-autocomplete",
          _vm.$attrs,
          false
        )
      ),
      _vm.showAddButton
        ? _c(
            VBtn,
            {
              staticClass: "mt-2 ml-5",
              attrs: { icon: "", outlined: "" },
              on: { click: _vm.selectedSuggestion },
            },
            [_c(VIcon, [_vm._v("mdi-plus")])],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }